import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "subscribe-setup"
    }}>{`Subscribe setup`}</h1>
    <p>{`In Chawkbazar we implement Subscribe email through our API. To make this work properly in shop End. You have to configure it in the API (BackEnd).`}</p>
    <p>{`Below .env variables are required to work Subscribe email. We will go through the whole process how you can get those env variable.`}</p>
    <pre><code parentName="pre" {...{}}>{`# Mailchimp Newslater
NEWSLETTER_API_KEY=
NEWSLETTER_LIST_ID=

`}</code></pre>
    <h2 {...{
      "id": "implementation-of-subscribe"
    }}>{`Implementation of Subscribe`}</h2>
    <p>{`In Chawkbazar we used `}<inlineCode parentName="p">{`spatie/laravel-Newsletter`}</inlineCode>{` package for as Newsletter manager. The `}<inlineCode parentName="p">{`spatie/laravel-newsletter`}</inlineCode>{` dependant on two Newsletter manager `}<inlineCode parentName="p">{`mailcoach`}</inlineCode>{` and `}<inlineCode parentName="p">{`mailchimp`}</inlineCode>{`. But in chawkbazar we used and configure only `}<inlineCode parentName="p">{`mailchimp`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "how-to-get-mailchimp-api-key"
    }}>{`How to Get Mailchimp API Key`}</h2>
    <ul>
      <li parentName="ul">{`Go to `}<a parentName="li" {...{
          "href": "https://mailchimp.com/signup/"
        }}>{`https://mailchimp.com/signup/`}</a>{` to signup for a mailchimp account.`}</li>
      <li parentName="ul">{`Once logged in, click on your profile name at the top right corner of the page. In the dropdown menu, select "Account."`}</li>
    </ul>
    <p><img alt="account-billing" src={require("./images/subscribe/account_billing.png")} /></p>
    <ul>
      <li parentName="ul">{`Within the Account page, navigate to the "Extras" dropdown menu and choose "API keys."`}</li>
      <li parentName="ul">{`On the API keys page, you'll see a section titled "Your API keys." If you have previously generated API keys, they will be listed here.`}</li>
    </ul>
    <p><img alt="api-key" src={require("./images/subscribe/api_key.png")} /></p>
    <ul>
      <li parentName="ul">{`If you don't have an existing API key, click on the "Create A Key" button. Otherwise, you can select an existing key from the list.`}</li>
    </ul>
    <p>{`Mailchimp will generate a new API key for you. You'll see a string of letters and numbers similar to the following format:`}</p>
    <pre><code parentName="pre" {...{}}>{`1234567890abcdef1234567890abcdef-us1
`}</code></pre>
    <ul>
      <li parentName="ul">{`Click the "Copy" button to copy the API key to your clipboard. Make sure to securely store this key as it provides access to your Mailchimp account.`}</li>
    </ul>
    <p>{`That's it! You now have your Mailchimp API key, which you can use to interact with the Mailchimp API and perform various tasks, such as managing subscribers, creating campaigns, and more.`}</p>
    <h2 {...{
      "id": "how-to-get-mailchimp-list-id"
    }}>{`How to Get Mailchimp List ID`}</h2>
    <ul>
      <li parentName="ul">{`From the Audience dashboard, select the desired audience or create a new one by clicking on the "Manage Audience" dropdown and choosing "View Audience" or "Create Audience," respectively.`}</li>
      <li parentName="ul">{`Within the Audience page, click on the "Manage Audience" dropdown again and select "Signup forms."`}</li>
    </ul>
    <p><img alt="audience" src={require("./images/subscribe/audience.png")} /></p>
    <ul>
      <li parentName="ul">{`You will be presented with various options for your signup form. Choose `}<inlineCode parentName="li">{`Embedded forms`}</inlineCode>{` for Form integrations."`}</li>
    </ul>
    <p><img alt="sign_up" src={require("./images/subscribe/sign_up.png")} /></p>
    <ul>
      <li parentName="ul">{`After selecting the desired form type, you'll be directed to the form builder. Click continue`}</li>
    </ul>
    <p><img alt="embeded_form" src={require("./images/subscribe/embeded_form.png")} /></p>
    <ul>
      <li parentName="ul">{`Locate the form code and look for the HTML snippet that contains the "form action" attribute. It should resemble the following code:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`form action="https://yourusername.us#list-id-number.campaign-archive.com/subscribe/post?u=xxxxxxxx&amp;id=xxxxxxxx"

`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`In the HTML snippet, find the "id" parameter in the form action URL. The value after the "id=" is your List ID. It will be a combination of letters and numbers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For example, in the above code snippet, the List ID would be represented by the "xxxxxxxx" placeholder.`}</p>
      </li>
    </ul>
    <p>{`That's it! You have now found the List ID for your Mailchimp newsletter subscription list.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      